import React from "react";
import { observer } from "mobx-react";
import classnames from "classnames/bind";

import Icon from "@components/icon";
import DropdownToggle from "@components/dropdown-toggle";

import BurgerDropdown from "./components/BurgerDropdown";

import { useStore } from "../../connect";

import styles from "./Burger.scss";

const cx = classnames.bind(styles);

const dropdownId = "burger";

const Burger = () => {
  const { header, profile } = useStore();

  const toggleMenu = () => {
    header.toggleDropdown(dropdownId);
  };

  const showBurgerMenu = header.openedDropdown === dropdownId;

  return (
    <DropdownToggle
      active={showBurgerMenu}
      onToggle={toggleMenu}
      className={cx("burger-wrapper", "hidden-by-compact-header", {
        "is-anonim": !profile.isLoggedIn,
      })}
      classNames={{
        dropdown: cx("dropdown-container"),
        trigger: cx("burger"),
      }}
      dropdown={<BurgerDropdown />}
    >
      {!showBurgerMenu ? (
        <>
          <Icon
            name="ic_burger-out"
            size="m"
            color="var(--glz-color-neutral-tone-5)"
          />
          {!!profile.counters.burger && (
            <div className={cx("burger-counter")} />
          )}
        </>
      ) : (
        <Icon
          name="ic_close-out"
          size="m"
          color="var(--glz-color-neutral-tone-5)"
        />
      )}
    </DropdownToggle>
  );
};

export default observer(Burger);
